import React from 'react';
import { ChevronRight } from 'react-bootstrap-icons';

export default function TreeViewLoading(props) {
	let { tree } = props;

	return (
		<div className='gtvcmp'>
			{tree.map((xe, xi) => (
				<div className='gtvsi' key={xi}>
					<div className={'ic'}>
						<div className='iic'>
							<ChevronRight />
						</div>
						<div className='ico w-100'>
							<div className='ibh w-100'>
								<div className='collectionid animated'>...</div>
								<div className='colltitle animated'>...</div>
							</div>
						</div>
					</div>
				</div>
			))}
		</div>
	);
}
